import React, { Component } from "react";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/thumbs/thumbs.min.css";

// import Swiper core and required modules
import SwiperCore, { Navigation, Thumbs } from "swiper/core";
import videoSlider1 from "../img/videoslider/video1.png";
import videoSlider2 from "../img/videoslider/play-button.svg";
import videothumb1 from "../img/videoslider/videothumb1.png";
import videothumb2 from "../img/videoslider/videothumb2.png";
import videothumb3 from "../img/videoslider/videothumb3.png";
import videothumb4 from "../img/videoslider/videothumb4.png";
import { connect } from "react-redux";

// install Swiper modules
SwiperCore.use([Navigation, Thumbs]);

class VideoSlider extends Component {
  //  const[thumbsSwiper, setThumbsSwiper] = useState(null);
  constructor(props) {
    super(props);

    this.state = {
      thumbsSwiper: null,
    };
  }

  render() {
    return (
      <>
        <div className="px-6">
          <div className="flex justify-between items-center lg:mt-24 md:mt-24 mt-0 mb-8">
            <h2 className="fsize28 sm-fsize16 font-bold">CHECK OUT ITV</h2>
          </div>
          <div className="swiper-thumb-h rounded-t-12px">
            <Swiper
              style={{
                "--swiper-navigation-color": "#fff",
                "--swiper-pagination-color": "#fff",
              }}
              spaceBetween={10}
              navigation={true}
              thumbs={{ swiper: this.state.thumbsSwiper }}
              className="mySwiper2 h-641vh"
            >
              {this.props.checkitv
                ? this.props.checkitv.map((data, index) => {
                    return (
                      <SwiperSlide className="video-sli-rem rounded-t-12px" key={index}>
                        <div className="relative video-h">
                          <h2 class="fsize28 font-bold inside-video-t sm-fsize14 text-white">
                            {data.b_title}
                          </h2>
                          {/* <video controls poster={videoSlider1} className="w-full rounded-t-15px"> */}
                          <video
                            controls
                            className="w-full rounded-t-15px max-h-641vh bg-black"
                          >
                            <source
                              src={
                                process.env.REACT_APP_IMAGE_BASE_MG +
                                "/" +
                                data.b_path
                              }
                              className="w-full rounded-t-15px "
                              type="video/mp4"
                            />
                            <source
                              src={
                                process.env.REACT_APP_IMAGE_BASE_MG +
                                "/" +
                                data.b_path
                              }
                              className="w-full rounded-t-15px"
                              type="video/ogg"
                            />
                          </video>
                          <div className="h-full flex justify-center items-center ">
                            <div className="absolute flex top-45per	 justify-center items-center ">
                              <img
                                src={videoSlider2}
                                alt="video"
                                className="w-auto h-auto sm-playicon-w  sm-playicon-w"
                              />
                            </div>
                          </div>

                          {/*  
                   <img src={process.env.REACT_APP_IMAGE_BASE_MG + '/'+ data.b_path} className="w-full rounded-t-15px" /> */}
                          {/* <img src={videoSlider1} className="w-full rounded-t-15px" /> 
                     <img src={videoSlider2} className="play-btn-cs" />
                     */}
                        </div>
                      </SwiperSlide>
                    );
                  })
                : ""}
            </Swiper>
            <Swiper
              breakpoints={{
                1366: {
                  slidesPerView: 5,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 30,
                },
                991: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
                420: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
                375: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
                320: {
                  slidesPerView: 1,
                  spaceBetween: 15,
                },
              }}
              spaceBetween={10}
              slidesPerView={5}
              freeMode={true}
              watchSlidesVisibility={true}
              watchSlidesProgress={true}
              className="mySwiper p-4 bg-black rounded-b-12px"
            >
              {this.props.checkitv
                ? this.props.checkitv.map((data, index) => {
                    return (
                      <SwiperSlide className="video-sli-rem rounded-12px" key={index}>
                        <div className="videoslider__whatnews ">
                          <div className="relative">
                            <video
                              src={
                                process.env.REACT_APP_IMAGE_BASE_MG +
                                "/" +
                                data.b_path
                              }
                              className="w-full bg-black max-h123px  sm-max-h123px rounded-12px"
                            />
                            <div className=" w-full flex justify-center items-center h-full">
                              <img
                                src={videoSlider2}
                                alt="video"
                                className=" items-center play-btn-thumb  absolute top-0  "
                              />
                            </div>
                          </div>

                          <div className="flex videoslider__whatnews_layer justify-center items-center">
                            <div class="hover-video-content">
                              <h6>{data.b_title}</h6>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })
                : ""}
              <SwiperSlide className="video-sli-rem rounded-12px">
                <div className="videoslider__whatnews ">
                  <div className="relative">
                    <img
                      src={videothumb1}
                      className="bg-black max-h123px  sm-max-h123px rounded-12px"
                    />
                    <img src={videoSlider2} className="play-btn-thumb" />
                  </div>

                  <div className="flex videoslider__whatnews_layer justify-center items-center">
                    <div class="hover-video-content">
                      <h6>In-branch Video Banking</h6>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide className="video-sli-rem rounded-12px">
                <div className="videoslider__whatnews ">
                  <div className="relative">
                    <img
                      src={videothumb2}
                      className="bg-black max-h123px  sm-max-h123px rounded-12px"
                    />
                    <img src={videoSlider2} className="play-btn-thumb" />
                  </div>

                  <div className="flex videoslider__whatnews_layer justify-center items-center">
                    <div class="hover-video-content">
                      <h6>In-branch Video Banking</h6>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide className="video-sli-rem rounded-12px">
                <div className="videoslider__whatnews ">
                  <div className="relative">
                    <img
                      src={videothumb1}
                      className="bg-black max-h123px  sm-max-h123px rounded-12px rounded-12px"
                    />
                    <img src={videoSlider2} className="play-btn-thumb" />
                  </div>

                  <div className="flex videoslider__whatnews_layer justify-center items-center">
                    <div class="hover-video-content">
                      <h6>In-branch Video Banking</h6>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide className="video-sli-rem rounded-12px">
                <div className="videoslider__whatnews ">
                  <div className="relative">
                    <img
                      src={videothumb4}
                      className="bg-black max-h123px  sm-max-h123px rounded-12px"
                    />
                    <img src={videoSlider2} className="play-btn-thumb" />
                  </div>

                  <div className="flex videoslider__whatnews_layer justify-center items-center">
                    <div class="hover-video-content">
                      <h6>In-branch Video Banking</h6>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide className="video-sli-rem rounded-12px">
                <div className="videoslider__whatnews ">
                  <div className="relative">
                    <img
                      src={videothumb3}
                      className="bg-black max-h123px  sm-max-h123px rounded-12px"
                    />
                    <img src={videoSlider2} className="play-btn-thumb" />
                  </div>

                  <div className="flex videoslider__whatnews_layer justify-center items-center">
                    <div class="hover-video-content">
                      <h6>In-branch Video Banking</h6>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide className="video-sli-rem rounded-12px">
                <div className="videoslider__whatnews ">
                  <div className="relative">
                    <img
                      src={videothumb1}
                      className="bg-black max-h123px  sm-max-h123px rounded-12px"
                    />
                    <img src={videoSlider2} className="play-btn-thumb" />
                  </div>

                  <div className="flex videoslider__whatnews_layer justify-center items-center">
                    <div class="hover-video-content">
                      <h6>In-branch Video Banking</h6>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    checkitv: state.Home.home.CHECKITV,
  };
};

export default connect(mapStateToProps)(VideoSlider);
